// extracted by mini-css-extract-plugin
module.exports = {"card":"BlogPost-module--card--1WE3W","media":"BlogPost-module--media--1H1R_"};